import { validateCPF } from 'validations-br';
import * as Yup from 'yup';

export const vetSignUpValidation = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  birthday: Yup.date().nullable(),
  cpf: Yup.string().test('is-cpf', 'CPF não é válido', (value: any) =>
    validateCPF(value)
  ),
  email: Yup.string().email('Email inválido').required('Campo obrigatório'),
  gender: Yup.string(),
  phone: Yup.string()
    .matches(
      /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/,
      'Digite o número corretamente'
    )
    .required('Campo obrigatório'),
  crmv: Yup.string()
    .matches(/^[0-9]+$/, 'CRMV deve conter apenas números')
    .required('Campo obrigatório'),
  uf: Yup.string().required('Campo obrigatório'),
  specialization: Yup.string().required('Campo obrigatório'),
});
